import React, { Fragment, useEffect, useState } from "react";
import Hero from "../../components/hero";

import AboutS2 from "../../components/AboutS2";
import Events from "../../components/Events";
import Footer from "../../components/footer";
import OurBlogs from "../../components/OurBlogs";
import PartnerSection from "../../components/PartnerSection";
import ProjectSection4 from "../../components/ProjectSection4";
import Scrollbar from "../../components/scrollbar";
import { GET_MENUS_ALL_NESTED } from "../../constant/constants";

const HomePage = () =>
{
  const [ homeId, setHomeId ] = useState();

  useEffect( () =>
  {
    fetch( `${ GET_MENUS_ALL_NESTED }` )
      .then( ( response ) => response.json() )
      .then( ( data ) =>
      {
        data.menus.find( ( e ) => ( e.name === "Home" ? setHomeId( e.id ) : null ) );
      } )
      .catch( () => { } );
  }, [] );


  const value =
    '<p>https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.3432361199048!2d90.41122508885499!3d23.735136600000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b9e61fa751a3%3A0xc7a23dee35be9928!2sNayapaltan%20islam%20tower!5e0!3m2!1sen!2sbd!4v1736308260051!5m2!1sen!2sbd" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade</p>';

  return (
    <Fragment>
      <Hero />
      <AboutS2 id={ homeId } />
      <PartnerSection />
      {/* <OurLivePrograms tClass={"wpo-testimonial-area-s3 "} /> */ }
      <Events id={ homeId } tClass={ "wpo-testimonial-area-s3 " } />

      <ProjectSection4 id={ homeId } />



      <OurBlogs id={ homeId } tClass={ "wpo-testimonial-area-s3 " } />
      <div
        style={ {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'auto',
          width: '100%',
        } }
      >
        <iframe
          title="Map"
          src={ value.slice( 3, -4 ) }
          style={ {
            height: '500px',
            width: '100%',
            border: 'none',
          } }
        ></iframe>
      </div>


      <Scrollbar />
      <Footer />
    </Fragment>
  );
};
export default HomePage;
